"use client"

import * as React from "react"

import Image from "next/image"
import checkMark from "/public/hire/check_circle1.webp"
import stepImg from "/public/hire/stepimg.webp"
import { motion, useAnimation, useInView } from "framer-motion";
import { trackEvent } from "../../analytics"
import { useContext } from "react"
import { advertiserAnalyticOptions } from "../../utils/functions"
import { isMobile } from "@/lib/utils"
import { SharedContext } from "@/context/SharedContext"
import { AdvertiserContext } from "@/context/AdvertiserContext"

export default function Steps() {

	const ref = React.useRef(null);
	const isInView = useInView(ref, { once: true });
	const control = useAnimation();
	
	React.useEffect(() => {
		if (isInView) {
			control.start("visible")
		}
	}, [isInView])

	const { utmParams } = useContext(SharedContext);
	const {	enterpriseLoginDetails } = useContext(AdvertiserContext);

	return (
		<section className="lg:container">
			<div
				className={
					"grid grid-cols-1 md:grid-cols-2 px-[16px] md:px-[40px] lg:px-[64px] gap-x-[77px] gap-y-[48px] md:gap-y-[0px] items-center py-[40px] md:py-[0px]"
				}
			>
				<motion.div
					ref={ref}
					variants={{ hidden: { opacity: 0, y: 95 }, visible: { opacity: 1, y: 0 } }}
					transition={{ duration: 0.8, delay: 0.2 }}
					initial={"hidden"}
					animate={control}
					className={"col-span-1 mt-[75px] md:mt-[0px]"}>
					<h3 className="custom-text">20% discount on first job post</h3>
					<h1 className={"sectiontitle"}>Post a job quickly in 3 easy steps</h1>
					<div className={"points mb-[20px] md:mb-[32px]"}>
						<ul className={""}>
							<li className={""}>
								<Image
									src={checkMark}
									className={"w-auto h-[24px] md:h-[28px]"}
									width={0}
									height={0}
									alt={""}
								/>
								<p className="mb-[0px]">Enter Job Details</p>
							</li>
							<li className={""}>
								<Image
									src={checkMark}
									className={"w-auto h-[24px] md:h-[28px]"}
									width={0}
									height={0}
									alt={""}
								/>
								<p className="mb-[0px]">Input Candidate requirements</p>
							</li>
							<li className={""}>
								<Image
									src={checkMark}
									className={"w-auto h-[24px] md:h-[28px]"}
									width={0}
									height={0}
									alt={""}
								/>
								<p className="mb-[0px]">Enter Company details</p>
							</li>
						</ul>
					</div>
					<a href={"#banner-section"} type={"submit"} className="btn w-[172px] cursor-pointer no-underline" onClick={()=>{
						      trackEvent({ name: 'tap_get_started', searchParams:  utmParams || {}, options: {...advertiserAnalyticOptions({ enterprise: !!enterpriseLoginDetails?.advertiserId }),label:"landing_page",section:"first_cta",device_type:isMobile()?"mobile":"web"} })
					}}>
						Get started Now
					</a>
				</motion.div>
				<div className={"col-span-1 flex justify-center"}>
					<Image
						src={stepImg}
						className={
							" w-[272px] md:w-auto h-[373px] lg:h-[585px] mx-[auto] md:mx-[0px]"
						}
						width={0}
						height={0}
						alt={""}
					/>
				</div>
			</div>
		</section>
	)
}
